'use strict';
import * as $j_com$002eraquo$002elaminar$002e$002dDom$002dApi$0024 from "./com.raquo.laminar.-Dom-Api$.js";
import * as $j_com$002eraquo$002elaminar$002einserters$002e$002dInsert$002dContext from "./com.raquo.laminar.inserters.-Insert-Context.js";
import * as $j_com$002eraquo$002elaminar$002enodes$002e$002dComment$002dNode from "./com.raquo.laminar.nodes.-Comment-Node.js";
import * as $j_java$002elang$002e$002dObject from "./java.lang.-Object.js";
import * as $j_scala$002escalajs$002eruntime$002e$002dAnon$002dFunction1$002e$0024$0024$002dLambda$0024412915ce24663401f4bc24349a746e1dbd693dc1 from "./scala.scalajs.runtime.-Anon-Function1.$$-Lambda$412915ce24663401f4bc24349a746e1dbd693dc1.js";
var $p;
/** @constructor */
function $c_Lcom_raquo_laminar_inserters_InsertContext$() {
}
export { $c_Lcom_raquo_laminar_inserters_InsertContext$ as $c_Lcom_raquo_laminar_inserters_InsertContext$ };
$p = $c_Lcom_raquo_laminar_inserters_InsertContext$.prototype = new $j_java$002elang$002e$002dObject.$h_O();
$p.constructor = $c_Lcom_raquo_laminar_inserters_InsertContext$;
/** @constructor */
function $h_Lcom_raquo_laminar_inserters_InsertContext$() {
}
export { $h_Lcom_raquo_laminar_inserters_InsertContext$ as $h_Lcom_raquo_laminar_inserters_InsertContext$ };
$h_Lcom_raquo_laminar_inserters_InsertContext$.prototype = $p;
$p.X4 = (function(parentNode, strictMode, hooks) {
  var sentinelNode = new $j_com$002eraquo$002elaminar$002enodes$002e$002dComment$002dNode.$c_Lcom_raquo_laminar_nodes_CommentNode("");
  $j_com$002eraquo$002elaminar$002e$002dDom$002dApi$0024.$m_Lcom_raquo_laminar_nodes_ParentNode$().qP(parentNode, sentinelNode, hooks);
  return this.Yi(parentNode, sentinelNode, strictMode);
});
$p.Yi = (function(parentNode, sentinelNode, strictMode) {
  return new $j_com$002eraquo$002elaminar$002einserters$002e$002dInsert$002dContext.$c_Lcom_raquo_laminar_inserters_InsertContext(parentNode, sentinelNode, strictMode, 0, (strictMode ? new Map() : null));
});
$p.Wk = (function(nodes) {
  var acc = new Map();
  nodes.a6(new $j_scala$002escalajs$002eruntime$002e$002dAnon$002dFunction1$002e$0024$0024$002dLambda$0024412915ce24663401f4bc24349a746e1dbd693dc1.$c_sjsr_AnonFunction1_$$Lambda$412915ce24663401f4bc24349a746e1dbd693dc1(((node) => {
    acc.set(node.aV(), node);
  })));
  return acc;
});
var $d_Lcom_raquo_laminar_inserters_InsertContext$ = new $j_java$002elang$002e$002dObject.$TypeData().i($c_Lcom_raquo_laminar_inserters_InsertContext$, "com.raquo.laminar.inserters.InsertContext$", ({
  ib: 1
}));
export { $d_Lcom_raquo_laminar_inserters_InsertContext$ as $d_Lcom_raquo_laminar_inserters_InsertContext$ };
var $n_Lcom_raquo_laminar_inserters_InsertContext$;
function $m_Lcom_raquo_laminar_inserters_InsertContext$() {
  if ((!$n_Lcom_raquo_laminar_inserters_InsertContext$)) {
    $n_Lcom_raquo_laminar_inserters_InsertContext$ = new $c_Lcom_raquo_laminar_inserters_InsertContext$();
  }
  return $n_Lcom_raquo_laminar_inserters_InsertContext$;
}
export { $m_Lcom_raquo_laminar_inserters_InsertContext$ as $m_Lcom_raquo_laminar_inserters_InsertContext$ };
